import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { reportLabels } from '../../constants/reportLabels';
import type { Report } from '../../types';
import ReportHistoryRow from './ReportHistoryRow';

interface ReportHistoryTableProps {
  reports: Report[];
  downloadingId: string | null;
  onDownload: (report: Report) => void;
}

const COLUMNS = [
  reportLabels.column_version,
  reportLabels.column_created,
  reportLabels.column_author,
  reportLabels.column_size,
  reportLabels.column_file,
  reportLabels.column_packages,
  reportLabels.column_download,
];

const ReportHistoryTable = ({ reports, downloadingId, onDownload }: ReportHistoryTableProps) => (
  <TableContainer>
    <Table size="small" aria-label={reportLabels.history_title}>
      <TableHead>
        <TableRow>
          {COLUMNS.map((column) => (
            <TableCell key={column}>{column}</TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {reports.map((report) => (
          <ReportHistoryRow key={report.id} report={report} isDownloading={downloadingId === report.id} onDownload={onDownload} />
        ))}
      </TableBody>
    </Table>
  </TableContainer>
);

export default ReportHistoryTable;
